export class SelectedItemAuthorityModel {
    canEdit: boolean = true;
    canView: boolean = true;

    constructor(canEdit: boolean, canView: boolean) {
        this.canEdit = canEdit;
        this.canView = canView;
    }
}
